import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    tokenMsgArquitectos: "",
    adminMsgArquitectos: []
  },
  mutations: {
    login(state, data) {
      state.adminMsgArquitectos = data.user;
      state.tokenMsgArquitectos = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.adminMsgArquitectos = [];
      state.tokenMsgArquitectos = "";
    },
    adminMsgArquitectos(state, data) {
      state.adminMsgArquitectos = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("adminMsgArquitectos", data);
    }
  }
});
